import React from 'react'
import { motion } from 'framer-motion'
import Brand from './Brand'

function Navbar() {
  return (
    <motion.div className='navigation' style={{zIndex:-9999}}>
      <Brand />
    </motion.div>
  )
}

export default Navbar